module.exports = __webpack_public_path__ + "static/DetectiveGui2-23812f4382728a02c0d4f86e8ed76356.webp";